import React, { useEffect, useState } from "react";

import { BookCheck, Filter, PanelTopOpen, Pencil } from "lucide-react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  Button,
  Card,
  Collapse,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledTooltip
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../../actions/baseActions";
import Breadcrumb from "../../../../../components/Breadcrumb";
import Loading from "../../../../../components/Loading";
import ProtectedRoute from "../../../../../components/ProtectedRoute";
import SelectFilter from "../../../../../components/SelectFilter";
import "./styles.css";
import URL from "../../../../../config/api";
import axios from "../../../../../config/axios";

const QuestionAnswer = ({ setFunc, question, index, sheet, token }) => {
  const answers = [
    { label: "A", value: 1 },
    { label: "B", value: 2 },
    { label: "C", value: 3 },
    { label: "D", value: 4 }
  ];

  const changeAnswer = value => {
    const answerSheet = { ...sheet };
    answerSheet.questions[index].current_answer_given = value;
    setFunc(answerSheet);
    setCurrentValue(value);
    axios.post(
      `${URL.api}activity/trail/grade_entry/update`,
      {
        application_id: answerSheet.application_id,
        answer: {
          question_id: question.question_id,
          option: value
        }
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
  };

  const [currentValue, setCurrentValue] = useState(
    question.current_answer_given ?? question.previous_answer_given
  );

  return (
    <div className="d-flex justify-content-between mt-2">
      {answers.map(answer => (
        <div
          key={answer.value}
          className={
            currentValue === answer.value
              ? "question-answer-letter-container-active"
              : "question-answer-letter-container"
          }
          onClick={() => changeAnswer(answer.value)}
        >
          <span
            className={
              currentValue === answer.value
                ? "question-answer-letter-active"
                : "question-answer-letter"
            }
          >
            {answer.label}
          </span>
        </div>
      ))}
    </div>
  );
};

const TrailGradeSend = props => {
  const [loading, setLoading] = useState(true);
  const [userListLoading, setUserListLoading] = useState(false);
  const [userId, setUserId] = useState();
  const [activityId, setActivityId] = useState();
  const [groupList, setGroupList] = useState([]);
  const [groupID, setGroupID] = useState(
    props.general.active_roles.group_id ?? null
  );
  const [regionList, setRegionList] = useState([]);
  const [regionID, setRegionID] = useState(
    props.general.active_roles.region_id ?? null
  );
  const [schoolList, setSchoolList] = useState([]);
  const [schoolID, setSchoolID] = useState(
    props.general.active_roles.school_id ?? null
  );
  const [classroomList, setClassroomList] = useState([]);
  const [classroomID, setClassroomID] = useState();
  const [trailList, setTrailList] = useState([]);
  const [trailID, setTrailID] = useState();
  const [usersTrailList, setUsersTrailList] = useState([]);
  const [answerSheet, setAnswerSheet] = useState();
  const [inputModal, setInputModal] = useState(false);
  const [collapseOpen, setCollapseOpen] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`${URL.api}access/group/list`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        });

        const groupList = response.data?.data.map(group => ({
          label: group.name,
          value: group.id
        }));
        setGroupList(groupList);

        const group = props.general.active_roles.group_id ?? 0;
        const region = props.general.active_roles.region_id ?? 0;
        const school = props.general.active_roles.school_id ?? 0;

        if (group) {
          setGroupID(group);
          await getRegions(group);

          if (region) {
            setRegionID(region);
            await getSchools(region, group);
          } else {
            getTrails(group, null, null, null);
          }

          if (school) {
            setSchoolID(school);
            getClassList(school);
            getTrails(group, region, school, null);
          } else {
            getTrails(group, region, null, null);
          }
        }
      } catch {
        toastr.error("Falha", "Falha ao buscar os dados!");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const getRegions = async id => {
    if (!id) {
      setRegionID(0);
      setSchoolID(0);
      setTrailID(0);
      setClassroomID(0);
      return;
    }
    try {
      const response = await axios.get(
        `${URL.api}access/region/listRegionFilter/${id}`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );
      const regionList = response.data?.data.map(region => ({
        label: region.name,
        value: region.id
      }));
      setRegionList(regionList);
    } catch {
      setRegionID(0);
      setSchoolID(0);
      setClassroomID(0);
    }
  };

  const getSchools = async (id, groupID) => {
    if (!id) {
      setSchoolID(0);
      setClassroomID(0);
      return;
    }
    try {
      const response = await axios.get(
        `${URL.api}access/school/listSchoolFilter/${groupID}/${id}`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );
      const schoolList = response.data?.data.map(school => ({
        label: school.name,
        value: school.id
      }));
      setSchoolList(schoolList);
    } catch {
      setSchoolID(0);
      setClassroomID(0);
    }
  };

  const getClassList = async schoolID => {
    try {
      const response = await axios.get(
        `${URL.api}community/room/list?class=true&school[]=${schoolID}`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );
      const classroomList = response.data?.data.map(classroom => ({
        label: classroom.name,
        value: classroom.id
      }));
      setClassroomList(classroomList);
    } catch {
      setClassroomList([]);
    }
  };

  const getTrails = async (groupID, regionID, schoolID, classroomID) => {
    try {
      const response = await axios.get(
        `${URL.api}activity/trail_allocation/statistics/getTrailsByFilter?group_id=${groupID}&region_id=${regionID}&school_id=${schoolID}&room_id=${classroomID}`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );
      const trailList = response.data?.data.map(trail => ({
        label: trail.name,
        value: trail.id
      }));
      setTrailList(trailList);
    } catch {
      setTrailID(0);
    }
  };

  const getStudentList = async () => {
    setUserListLoading(true);
    try {
      const response = await axios.get(
        `${URL.api}activity/trail_allocation/statistics/usersByTrail/${trailID}`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` },
          params: {
            group_id: groupID,
            region_id: regionID,
            school_id: schoolID
          }
        }
      );
      const userList = response.data?.data.map(user => ({
        ...user,
        evaluations: user?.evaluations.sort((a, b) => a.step - b.step)
      }));
      setUsersTrailList(userList);
    } catch {
      setUsersTrailList([]);
    } finally {
      setUserListLoading(false);
    }
  };

  const openModal = async (activityID, userID) => {
    try {
      const response = await axios.post(
        `${URL.api}activity/trail/grade_entry/answers_sheet`,
        {
          activity_id: activityID,
          user_id: userID
        },
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );
      setUserId(userID);
      setActivityId(activityID);
      setAnswerSheet(response.data.data);
      setInputModal(true);
    } catch {
      toastr.error("Falha", "Falha ao abrir o modal!");
    }
  };

  const sendAnswerSheet = async () => {
    try {
      await axios.post(
        `${URL.api}activity/trail/grade_entry/finish`,
        {
          application_id: answerSheet.application_id,
          execution_id: answerSheet.execution_id,
          answers: answerSheet.questions.map(answer => ({
            question_id: answer.question_id,
            option: answer.current_answer_given ?? answer.previous_answer_given
          }))
        },
        { headers: { Authorization: `Bearer ${props.user.token}` } }
      );
      setInputModal(false);
      setAnswerSheet();
    } catch {
      toastr.error("Falha", "Falha ao enviar o gabarito!");
    }
  };

  const toggleCollapse = id => {
    setCollapseOpen(prevState => (prevState === id ? null : id));
  };

  return (
    <div>
      <Breadcrumb current={props.currentRoute} />
      <Modal
        isOpen={inputModal}
        centered
        toggle={() => {
          setInputModal(false);
          setAnswerSheet();
        }}
      >
        <ModalHeader className="d-flex flex-column">
          <h4>Lançamento de gabarito</h4>
          <p className="text-muted">Selecione as alternativas marcadas.</p>
        </ModalHeader>
        <ModalBody className="p-4">
          {answerSheet &&
            answerSheet.questions.map((question, index) => (
              <QuestionAnswer
                key={question.question_id}
                setFunc={setAnswerSheet}
                question={question}
                sheet={answerSheet}
                index={index}
                token={props.user.token}
              />
            ))}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              setInputModal(false);
              setAnswerSheet();
            }}
          >
            Cancelar
          </Button>
          <Button color="primary" onClick={sendAnswerSheet}>
            Confirmar
          </Button>
        </ModalFooter>
      </Modal>
      <div className="col-12 col-sm-6">
        <h2>Lançamento</h2>
        <p className="text-muted">
          Lançamento de gabarito das trilhas de reposição.
        </p>
      </div>
      <Col sm="12" md="12" className="mb-4">
        <Row>
          <Col sm="12" md="2">
            <SelectFilter
              title="Grupo"
              placeholder="Grupo"
              value={groupID}
              setFunction={id => {
                setGroupID(id);
                getRegions(id);
                getTrails(id, null, null, null);
              }}
              options={groupList}
              disabled={!!props.general.active_roles.group_id}
            />
          </Col>
          <Col sm="12" md="2">
            <SelectFilter
              title="Regiões"
              placeholder="Região"
              value={regionID}
              setFunction={id => {
                setRegionID(id);
                getSchools(id, groupID);
                getTrails(groupID, id, null, null);
              }}
              options={regionList}
              disabled={!groupID || !!props.general.active_roles.region_id}
            />
          </Col>
          <Col sm="12" md="2">
            <SelectFilter
              title="Escolas"
              placeholder="Escola"
              value={schoolID}
              setFunction={id => {
                setSchoolID(id);
                getClassList(id);
                getTrails(groupID, regionID, id, null);
              }}
              options={schoolList}
              disabled={!regionID || !!props.general.active_roles.school_id}
            />
          </Col>
          <Col sm="12" md="2">
            <SelectFilter
              title="Turmas"
              placeholder="Turma"
              value={classroomID}
              setFunction={id => {
                setClassroomID(id);
                getTrails(groupID, regionID, schoolID, id);
              }}
              options={classroomList}
              disabled={!schoolID || !classroomList}
            />
          </Col>
          <Col sm="12" md="2">
            <SelectFilter
              title="Trilha"
              placeholder="Trilha"
              value={trailID}
              setFunction={id => {
                setTrailID(id);
              }}
              options={trailList}
              disabled={!groupID}
            />
          </Col>
          <Col
            sm="12"
            md="2"
            className="d-flex justify-content-center align-items-end"
          >
            <Button
              color="primary"
              style={{ minHeight: "38px" }}
              className="d-flex justify-content-center align-items-center rounded-left w-100"
              onClick={getStudentList}
              disabled={!trailID}
            >
              <Filter size={16} className="mr-2" />
              Filtrar
            </Button>
          </Col>
        </Row>
      </Col>
      {usersTrailList.length > 0 ? (
        <>
          {usersTrailList.map(student => (
            <Col sm="12" md="6" key={student.id}>
              <Card
                key={student.id}
                className="rounded-lg cursor"
                onClick={() => toggleCollapse(student.id)}
              >
                <div className="d-flex align-items-center p-4 justify-content-between">
                  <div className="d-flex flex-column">
                    {student.name.toUpperCase()}
                    <small className="text-muted">
                      {
                        classroomList.filter(
                          item => item.value === classroomID
                        )[0]?.label
                      }
                    </small>
                  </div>
                  <Button color="light">
                    <PanelTopOpen size={16} />
                  </Button>
                </div>
                <Collapse isOpen={collapseOpen === student.id}>
                  <div
                    className="d-flex align-items-center justify-content-between p-4"
                    style={{ overflowX: "auto" }}
                  >
                    {student.evaluations.map((execution, idx) => (
                      <div key={execution.activity_id} className="mr-2">
                        <Button
                          className="align-items-center"
                          color={
                            student.executions.some(
                              exec => exec.activity_id === execution.activity_id
                            )
                              ? "success"
                              : "info"
                          }
                          onClick={() =>
                            openModal(execution.activity_id, execution.user_id)
                          }
                        >
                          {student.executions.some(
                            exec => exec.activity_id === execution.activity_id
                          ) ? (
                            <Pencil size={16} className="mr-2" />
                          ) : (
                            <BookCheck size={16} className="mr-2" />
                          )}
                          P{idx + 1}
                        </Button>
                      </div>
                    ))}
                  </div>
                </Collapse>
              </Card>
            </Col>
          ))}
        </>
      ) : (
        <>
          {userListLoading ? (
            <Loading />
          ) : (
            <p className="w-100 text-center">
              Selecione ao menos uma trilha e um grupo para o lançamento de
              notas.
            </p>
          )}
        </>
      )}
      <ProtectedRoute routeId={props.currentRoute} />
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch => bindActionCreators({ logout }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TrailGradeSend);
